// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WEBPUSH_NOTIFICATIONS_SUBSCRIBED_DESKTOP = "Zapla si upozornenia v prehliada\u010di.";
export const WEBPUSH_NOTIFICATIONS_SUBSCRIBED_MOBILE = "Zapla si upozornenia v mobile.";
